import QueryGenerator from "./queries/QueryGenerator";
import ViewStateGenerator from "./views/ViewStateGenerator";
export default async (type) => {
  const query = QueryGenerator();
  const state = await ViewStateGenerator(type);
  return [query, state];
};
